import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { showIconByServiceId } from "../../../helpers/showIconByServiceId";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const Row = ({ item }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const calculateDiscount = () => {
    if (item.discount_type === "const") {
      return item.discount;
    }
    return parseFloat((item.price * item.discount) / 100).toFixed(2);
  };
  return (
    <>
      <TableRow
        key={item.request_id}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          backgroundColor: "#E5EDFF",
          borderBlock: "2px solid #3F78E0",
        }}
      >
        <TableCell
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          {item?.request_id}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          {item?.offerName || (
            <div className="flex justify-center w-full">
              <IoMdClose style={{ color: "red" }} />
            </div>
          )}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          {item?.user_name}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          {item?.price}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          ${calculateDiscount()}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          <a
            className="inline-block w-full max-w-48 truncate"
            href={item?.panel_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item?.panel_url}
          </a>
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
            {item?.payment_method === 'manually' ? 'Cash Payment (via Marketer)' : item?.payment_method}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          {item?.created_at}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          <span
            className={`badge w-24 text-darkTextColor ${
              item?.status_payment === "paid"
                ? "bg-[#28a745]"
                : item?.status_payment === "pending"
                ? "bg-[#f7cb73]"
                : "bg-[#ff6877]"
            }`}
          >
            {item?.status_payment}
          </span>
        </TableCell>
        <TableCell
          align="center"
          sx={{
            textAlign: "center",
            color: "#333333",
            borderInlineEnd: "1px solid #3F78E0",
          }}
        >
          {item.status}
        </TableCell>
        <TableCell
          sx={{
            textAlign: "center",
            color: "#333333",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {item?.offerId && (
            <Button
              sx={{
                backgroundColor: "#3F78E0",
                color: "#fff",
                boxShadow: `0px 3px 3px #00000040, inset 0px 4px 7px #FFFFFF40`,
                borderRadius: "6px",
                width: "85px",
                fontSize: "12px",
              }}
              onClick={() => {
                // Handle reorder for offer
                navigate(`/OffersDetails/${item?.offerId}`);
              }}
            >
              Re Order
            </Button>
          )}
          {(item?.status_payment === "pending" || item?.status_payment === "not selected") &&
            item?.status !== "complete" && (
              <Button
                sx={{
                  backgroundColor: "#3F78E0",
                  color: "#fff",
                  boxShadow: `0px 3px 3px #00000040, inset 0px 4px 7px #FFFFFF40`,
                  borderRadius: "6px",
                  width: "85px",
                  fontSize: "12px",
                }}
                onClick={() => {
                  // Handle reorder for offer
                  navigate(`/OffersInvoice?invoice_id=${item?.uuid}`);
                }}
              >
                Pay
              </Button>
            )}
        </TableCell>
      </TableRow>
      {/*offer details */}
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, width: "100%" }}>
              <Typography variant="h6" gutterBottom component="div">
                Offer details
              </Typography>
              {item?.RequestOfferDetails?.length > 0 ? (
                <Table size="large" aria-label="types">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">ID</TableCell>
                      <TableCell align="center">icon</TableCell>
                      <TableCell align="center">service name</TableCell>
                      <TableCell align="center">title</TableCell>
                      <TableCell align="center">description</TableCell>
                      <TableCell align="center">Logo</TableCell>
                      <TableCell align="center">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {item?.RequestOfferDetails?.map((subItem) => (
                      <TableRow key={subItem?.id}>
                        <TableCell align="center">{subItem?.id}</TableCell>
                        <TableCell align="center">
                          <div
                            className="icons"
                            style={{
                              height: "40px",
                              display: "flex",
                              gap: "8px",
                              justifyContent: "center",
                              overflow: "hidden",
                              width: "100%",
                              paddingInline: "5px",
                            }}
                          >
                            <img
                              src={showIconByServiceId(subItem?.our_service_id)}
                              alt="icon"
                              style={{
                                maxHeight: "37px",
                                maxWidth: "40px",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          {subItem?.our_service_name}
                        </TableCell>
                        <TableCell align="center">{subItem?.title}</TableCell>
                        <TableCell align="center">
                          {subItem?.description_offer}
                        </TableCell>
                        <TableCell align="center">Waiting logo</TableCell>
                        <TableCell align="center">
                          <span
                            className={`badge text-darkTextColor ${
                              subItem?.status === "complete"
                                ? "bg-[#114787]"
                                : subItem?.status === "active"
                                ? "bg-[#28a745]"
                                : "bg-[#ff6877]"
                            }`}
                          >
                            {subItem?.status}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>No Details available</Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default Row;
